import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { AuthContext } from './contexts/AuthContext';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import RequirePlan from './components/RequirePlan';

import PrivateLayout from './routes/PrivateLayout';
import Login from './pages/Auth/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Planos from './pages/Planos';
import Clientes from './pages/Clientes/Clientes';
// import Pedidos from './pages/Pedidos/Pedidosold';
import Pedidos from './pages/Pedidos/Pedidos';
import Contas from './pages/Contas/Contas';
import Equipamentos from './pages/Equipamentos';
import ConfiguracaoEmpresa from './pages/Ajustes/index.tsx';

import { Private } from './routes/Private';
import { Adm } from './routes/adm';
import { SuperAdmin } from './routes/SuperAdmin';
import Layout from './components/Layout/Layout';
import CreateUsers from './pages/CreateUsers';
import PainelWhatsapp from './pages/Ajustes/PainelWhatsapp.tsx';
import PainelEmail from './pages/Ajustes/PainelEmail.tsx';
import RelatorioEmail from './pages/Notificacoes/RelatorioEmail.tsx';
import RelatorioWhatsapp from './pages/Notificacoes/RelatorioWhatsapp.tsx';
import Empresas from './pages/Superadmin/Empresas.jsx';
import ResetPassword from './pages/Auth/ResetPassword.jsx';
import ForgotPassword from './pages/ForgotPassword/index.jsx';
import SuperAdminDashboard from './pages/Superadmin/SuperAdminDashboard.jsx';
import VerifyReceipt from './pages/VerifyReceipt/VerifyReceipt.tsx';
import PlanosInterno from 'pages/planoInterno';
import ComprovanteVeiculacao from 'pages/Relatorios/ComprovanteVeiculacao';
import RelatorioEquipamentos from 'pages/Relatorios/RelatorioEquipamentos.tsx';
import ContratosExpirando from 'pages/Relatorios/ContratosExpirando';
import ModeloContratos from './pages/Contratos/ModelosContratos';
import Contratos from './pages/Contratos/Contratos';
import Vitrine from './pages/Vitrine';

function App() {

  useEffect(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => console.log('✅ SW registrado:', reg.scope))
      .catch((err) => console.log('❌ Erro ao registrar SW:', err));
  }
}, []);


  function NotFound() {
    const { signed, loadingAuth } = useContext(AuthContext);
    if (loadingAuth) return null;
    return <Navigate to={signed ? '/dashboard' : '/login'} replace />;
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <Router>
        <Routes>
          {/* ─── Rotas Públicas ─── */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/esqueci-senha" element={<ForgotPassword />} />
          <Route path="/verificar-recibo" element={<VerifyReceipt />} />
          <Route path="/vitrine/:companyId" element={<Vitrine />} />

          {/* ─── Rotas Privadas ─── */}
          <Route element={<PrivateLayout />}>
            <Route path="/dashboard"            element={<Dashboard />} />
            <Route path="/planos"               element={<Planos />} />
            <Route path="/clientes"             element={<Clientes />} />
            <Route path="/pedidos"              element={<Pedidos />} />
            <Route path="/contas"               element={<Contas />} />
            <Route path="/equipamentos"         element={<Equipamentos />} />
            <Route path="/configuracao-empresa" element={<ConfiguracaoEmpresa />} />
            <Route path="/verificarrecibo"      element={<VerifyReceipt />} />
            <Route path="/upgrade"              element={<PlanosInterno />} />
            <Route path="/relatorios/contratos-expirando" element={<ContratosExpirando />} />
            <Route path="/contratos/modelos"            element={<ModeloContratos />} />
            <Route path="/contratos"            element={<Contratos />} />

            {/* 🟠 ENTERPRISE — Notificações */}
            <Route path="/notificacoes/whatsapp" element={
              <RequirePlan feature="whatsapp">
                <PainelWhatsapp />
              </RequirePlan>
            } />
            <Route path="/notificacoes/email" element={
              <RequirePlan feature="emailNotificacao">
                <PainelEmail />
              </RequirePlan>
            } />

            {/* 🔵 PRO — Relatórios de Equipamentos/Veiculação */}
            <Route path="/relatorios/equipamentos" element={
              <RequirePlan feature="relatorios">
                <RelatorioEquipamentos />
              </RequirePlan>
            } />
            <Route path="/relatorios/veiculacao" element={
              <RequirePlan feature="relatorios">
                <ComprovanteVeiculacao />
              </RequirePlan>
            } />

            {/* 🟠 ENTERPRISE — Relatórios de Notificações */}
            <Route path="/relatorios/whatsapp" element={
              <RequirePlan feature="relatoriosNotificacao">
                <RelatorioWhatsapp />
              </RequirePlan>
            } />
            <Route path="/relatorios/email" element={
              <RequirePlan feature="relatoriosNotificacao">
                <RelatorioEmail />
              </RequirePlan>
            } />

            {/* ─── Superadmin ─── */}
            <Route path="/super/empresas" element={
              <SuperAdmin>
                <Empresas />
              </SuperAdmin>
            } />
            <Route path="/super/dashboard" element={
              <SuperAdmin>
                <SuperAdminDashboard />
              </SuperAdmin>
            } />

            <Route path="*" element={<NotFound />} />
          </Route>

          {/* ─── Rota de Admin ─── */}
          <Route path="/createuser" element={
            <Private>
              <Adm>
                <Layout>
                  <CreateUsers />
                </Layout>
              </Adm>
            </Private>
          } />
        </Routes>
      </Router>
    </>
  );
}

export default App;

